<div style="width: 100%">
    <button style="float: right;" title="{{'labels.close' | translate}}" (click)="closeDialog()" mat-icon-button color="warn"
            aria-label="icon-button save">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div style="width: 100%; height: 50px; display: flex">
    <h2 style="text-align: center; width: 100%">{{'labels.noteList' | translate}}:</h2>

</div>
<div style="text-align: center">

    <ng-container *ngIf="this.notesList.length === 0">
      {{'labels.noNote' | translate}}
    </ng-container>
    <div style="text-align: left;">
        <mat-selection-list #viste [multiple]="false">
            <ng-container *ngIf="this.notesList.length != 0">
                <div *ngFor="let note of this.notesList">
                    <button style="float:right; color:{{this.squareColor}};"
                            title="{{'labels.deleteNote' | translate}}"
                            mat-button
                            aria-label="{{'labels.deleteNote' | translate}}" (click)=deleteNote(note.id)>
                        <mat-icon>delete</mat-icon>
                    </button>
                    <mat-list-item style="width: 80%;">
                        <div>
                            <b>{{note.userCompleteName}}</b><span
                                style="margin-left: 10px;">{{note.comment}}</span><span
                                style="margin-left: 10px; color: darkgray">{{this.apiService.TransformDataFormat(note.creationDate)}}</span>
                        </div>
                    </mat-list-item>

                </div>

            </ng-container>
        </mat-selection-list>
    </div>
    <br>
    <hr>
    <div style="text-align: center; margin-top: 5%">
        <button mat-stroked-button (click)="addNoteTrue()">{{this.addLabel}}</button>
    </div>
    <div *ngIf="this.showAddNote" style="margin-top: 5%">
        <mat-form-field appearance="fill" style="width: 60%">
            <mat-label>{{'labels.noteText' | translate}}</mat-label>
            <textarea matInput required rows="3" [(ngModel)]="this.newNote"
                      placeholder="{{'labels.insertNote' | translate}}" type="text"></textarea>
        </mat-form-field>
        <br>
        <button mat-stroked-button (click)="saveNewNote()">{{'labels.save' | translate}}</button>

    </div>
    <br>
</div>

